import globalPublicRoute from 'global/components/lib/routes/PublicRoute'

export default globalPublicRoute()
